// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/siminn-icons.eot?l0kdxi", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../fonts/siminn-icons.ttf?l0kdxi", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../fonts/siminn-icons.woff?l0kdxi", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../fonts/siminn-icons.svg?l0kdxi", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../fonts/BrixSansRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../fonts/BrixSansRegular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../fonts/BrixSansMedium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../fonts/BrixSansMedium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../fonts/BrixSansBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../fonts/BrixSansBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#siminn-icons" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'siminn-icons';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src:
            url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
            url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
            url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
            url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'Hvd fonts';
    src:
            url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2'),
            url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
    font-weight: 300;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts';
    src:
            url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2'),
            url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts';
    src:
            url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff2'),
            url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts';
    src:
            url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff2'),
            url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
    font-weight: 200;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts';
    src:
            url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff2'),
            url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff');
    font-weight: 700;
    font-style: normal;
}
@font-face {
    font-family: 'Font awesome 5 brands 400';
    src: url('https://static.siminn.is/tilbod/5c371db5a343b0c9b4580468_Font%20Awesome%205%20Brands-Regular-400.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Font awesome 5 pro 400';
    src: url('https://static.siminn.is/tilbod/5c371db5a343b0d2c158046a_Font%20Awesome%205%20Pro-Regular-400.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Font awesome 5 pro solid 900';
    src: url('https://static.siminn.is/tilbod/5c371db5a343b0b1f4580469_Font%20Awesome%205%20Pro-Solid-900.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Font awesome 5 pro 300';
    src: url('https://static.siminn.is/tilbod/5c371db5a343b0aabc58046b_Font%20Awesome%205%20Pro-Solid-900.otf') format('opentype');
    font-weight: 300;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Black.woff2') format('woff2');
    font-weight: 900;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Bold.woff2') format('woff2');
    font-weight: 700;
    font-style: italic;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');
    font-weight: 200;
    font-style: italic;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');
    font-weight: 200;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Black.woff2') format('woff2');
    font-weight: 900;
    font-style: italic;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');
    font-weight: 300;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-RegularItalic.woff2') format('woff2');
    font-weight: 300;
    font-style: italic;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-RegularItalic.woff2') format('woff2');
    font-weight: 500;
    font-style: italic;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Hvd fonts brixslab';
    src: url('https://static.siminn.is/tilbod/BrixSansWeb-RegularItalic.woff2') format('woff2');
    font-weight: 400;
    font-style: italic;
}

* {
    outline: 0;
}

body {
    background: url("https://static.siminn.is/tilbod/64e786271fad9a45717f3499__F4A7283l.jpg") no-repeat fixed; /* For WebKit*/    /* Mozilla*/      /* Opera*/
    background-size: cover;         /* Generic*/
}

body,
html {
    color: var(--blue);
    font-size: 14px;
    box-sizing: border-box;
    margin: 0;
}

body {
    font-family: 'Hvd fonts', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

a {
    text-decoration: none;
    color: var(--white);
    transition: color 0.2s ease-out;
}

a:focus {
    text-decoration: none;
}

a:hover,
a:active {
    color: color(var(--blue) lightness(-10%));
}

a.underlined {
    text-decoration: underline;
}

p {
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 300;
    line-height: 1.5;
}

b {
    font-weight: 700;
}

strong,
b {
    font-weight: 700;
}

p a:hover {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/css/core.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,4CAA+C;IAC/C;;;;iEAI6E;IAC7E,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB;;kEAE8D;IAC9D,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB;;kEAE8D;IAC9D,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB;;kEAE6D;IAC7D,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB;;kEAE8D;IAC9D,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB;;mEAE2D;IAC3D,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,wCAAwC;IACxC,mIAAmI;IACnI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,qCAAqC;IACrC,gIAAgI;IAChI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,2CAA2C;IAC3C,8HAA8H;IAC9H,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,qCAAqC;IACrC,8HAA8H;IAC9H,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,mFAAmF;IACnF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,kFAAkF;IAClF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,qFAAqF;IACrF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,kFAAkF;IAClF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,qFAAqF;IACrF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,mFAAmF;IACnF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,qFAAqF;IACrF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,2FAA2F;IAC3F,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,qFAAqF;IACrF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,2FAA2F;IAC3F,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,qFAAqF;IACrF,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,iCAAiC;IACjC,2FAA2F;IAC3F,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yGAAyG,EACzE,cAAc,KACd,WAAW,OACX,SAAS;IACzC,sBAAsB,UAAU,WAAW;AAC/C;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["@font-face {\n    font-family: 'siminn-icons';\n    src: url('../../fonts/siminn-icons.eot?l0kdxi');\n    src:\n            url('../../fonts/siminn-icons.eot?l0kdxi#iefix') format('embedded-opentype'),\n            url('../../fonts/siminn-icons.ttf?l0kdxi') format('truetype'),\n            url('../../fonts/siminn-icons.woff?l0kdxi') format('woff'),\n            url('../../fonts/siminn-icons.svg?l0kdxi#siminn-icons') format('svg');\n    font-weight: 400;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Hvd fonts';\n    src:\n            url('../../fonts/BrixSansRegular.woff2') format('woff2'),\n            url('../../fonts/BrixSansRegular.woff') format('woff');\n    font-weight: 300;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts';\n    src:\n            url('../../fonts/BrixSansRegular.woff2') format('woff2'),\n            url('../../fonts/BrixSansRegular.woff') format('woff');\n    font-weight: 400;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts';\n    src:\n            url('../../fonts/BrixSansMedium.woff2') format('woff2'),\n            url('../../fonts/BrixSansMedium.woff') format('woff');\n    font-weight: 500;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts';\n    src:\n            url('../../fonts/BrixSansRegular.woff2') format('woff2'),\n            url('../../fonts/BrixSansRegular.woff') format('woff');\n    font-weight: 200;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts';\n    src:\n            url('../../fonts/BrixSansBold.woff2') format('woff2'),\n            url('../../fonts/BrixSansBold.woff') format('woff');\n    font-weight: 700;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Font awesome 5 brands 400';\n    src: url('https://static.siminn.is/tilbod/5c371db5a343b0c9b4580468_Font%20Awesome%205%20Brands-Regular-400.otf') format('opentype');\n    font-weight: 400;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Font awesome 5 pro 400';\n    src: url('https://static.siminn.is/tilbod/5c371db5a343b0d2c158046a_Font%20Awesome%205%20Pro-Regular-400.otf') format('opentype');\n    font-weight: 400;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Font awesome 5 pro solid 900';\n    src: url('https://static.siminn.is/tilbod/5c371db5a343b0b1f4580469_Font%20Awesome%205%20Pro-Solid-900.otf') format('opentype');\n    font-weight: 400;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Font awesome 5 pro 300';\n    src: url('https://static.siminn.is/tilbod/5c371db5a343b0aabc58046b_Font%20Awesome%205%20Pro-Solid-900.otf') format('opentype');\n    font-weight: 300;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Black.woff2') format('woff2');\n    font-weight: 900;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Bold.woff2') format('woff2');\n    font-weight: 700;\n    font-style: italic;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');\n    font-weight: 200;\n    font-style: italic;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Bold.woff2') format('woff2');\n    font-weight: 700;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');\n    font-weight: 200;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Black.woff2') format('woff2');\n    font-weight: 900;\n    font-style: italic;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');\n    font-weight: 300;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-RegularItalic.woff2') format('woff2');\n    font-weight: 300;\n    font-style: italic;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');\n    font-weight: 500;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-RegularItalic.woff2') format('woff2');\n    font-weight: 500;\n    font-style: italic;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-Regular.woff2') format('woff2');\n    font-weight: 400;\n    font-style: normal;\n}\n@font-face {\n    font-family: 'Hvd fonts brixslab';\n    src: url('https://static.siminn.is/tilbod/BrixSansWeb-RegularItalic.woff2') format('woff2');\n    font-weight: 400;\n    font-style: italic;\n}\n\n* {\n    outline: 0;\n}\n\nbody {\n    background: url(\"https://static.siminn.is/tilbod/64e786271fad9a45717f3499__F4A7283l.jpg\") no-repeat fixed;\n    -webkit-background-size: cover; /* For WebKit*/\n    -moz-background-size: cover;    /* Mozilla*/\n    -o-background-size: cover;      /* Opera*/\n    background-size: cover;         /* Generic*/\n}\n\nbody,\nhtml {\n    color: var(--blue);\n    font-size: 14px;\n    box-sizing: border-box;\n    margin: 0;\n}\n\nbody {\n    font-family: 'Hvd fonts', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\na {\n    text-decoration: none;\n    color: var(--white);\n    transition: color 0.2s ease-out;\n}\n\na:focus {\n    text-decoration: none;\n}\n\na:hover,\na:active {\n    color: color(var(--blue) lightness(-10%));\n}\n\na.underlined {\n    text-decoration: underline;\n}\n\np {\n    margin-bottom: 20px;\n    font-size: 20px;\n    font-weight: 300;\n    line-height: 1.5;\n}\n\nb {\n    font-weight: 700;\n}\n\nstrong,\nb {\n    font-weight: 700;\n}\n\np a:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
